import _ from 'lodash';
import assetTypeApi from '@/api/assetTypeApi';
import { fetchOnce } from '@/store/utils/fetchOnce';
import config from '@/config/env-constants';

export default {
	namespace: true,

	state: {
		assetTypes: {},
		currAssetType: {},
		assetTypesLoaded: false,
	},

	mutations: {
		SET_ALL_ASSET_TYPES(state, assetTypes) {
			state.assetTypes = assetTypes
		},
		SET_CURR_ASSET_TYPE(state, assetType) {
			state.currAssetType = assetType
		},
		SET_ASSET_TYPES_LOADED(state, val) {
			state.assetTypesLoaded = val;
		},
	},

	actions: {
		setAllAssetTypes(vuexContext, assetTypes) {
			vuexContext.commit('SET_ALL_ASSET_TYPES', assetTypes);
		},
		updateAllAssetTypes(vuexContext, newAssetTypes) {
			let assetTypes = vuexContext.getters.assetTypes;

			_.forEach(newAssetTypes, (value, key) => {
				assetTypes[key] = value;
			});

			vuexContext.commit('SET_ALL_ASSET_TYPES', assetTypes);
		},

		fetchAssetTypesIfNeeded({ state, getters, commit }, payload = {}) {
			if (state.assetTypesLoaded) return Promise.resolve();
			return fetchOnce('assetTypes', () => {
				let currUserId = payload.currUserId || getters.loggedUser.id;
				let view = payload.view || (getters.isSuperAdmin ? config.view.ADMIN : config.view.COMPANY);
				let filterBy = payload.filterBy || {
					companyId: getters.loggedUserCompany.id,
					companyAccess: getters.loggedUser.companyAccess,
				};

				return assetTypeApi.getAssetTypes(filterBy, view, currUserId).then(({ data }) => {
					if (data.isSuccess) {
						commit('SET_ALL_ASSET_TYPES', data.assetTypes);
						commit('SET_ASSET_TYPES_LOADED', true);
					}
					return data;
				});
			});
		},
	},

	getters: {
		assetTypes(state) {
			if (!_.isEmpty(state.assetTypes)) {
				return state.assetTypes;
			}
			return {};
		},
		currAssetType(state) {
			if (!_.isEmpty(state.currAssetType)) {
				return state.currAssetType;
			}
			return {};
		},
	}
}
